import React, { useEffect, useState } from "react";
import { Container, Hero, IconPaperclip } from "@web-monorepo/mds";
import { logSparksEvent } from "@src/utils/sparks/logSparksEvent";
import { parseFeatureSupportStatus } from "@src/utils/sparks/parseFeatureSupportStatus";
import { ANDROID_PLAY_STORE_URL, IOS_APP_STORE_URL } from "../shared/constants";
import { SparksPlatformSupportCard } from "./SparksPlatformSupportCard";
import { ANDROID_MIN_VERSION, getHeroCopy, getSupportParam, IOS_MIN_VERSION, type SupportState } from "./constants";

const DEFAULT_SUPPORT_STATE: SupportState = {
  android: parseFeatureSupportStatus(),
  ios: parseFeatureSupportStatus(),
};

export const SparksFeatureSupportContent = () => {
  const [supportState, setSupportState] = useState<SupportState>(DEFAULT_SUPPORT_STATE);

  useEffect(() => {
    void logSparksEvent({
      eventName: "web.external_page.sparks.feature_support.page_view",
      eventValue: window.location.href,
    });

    const params = new URLSearchParams(window.location.search);
    setSupportState({
      android: parseFeatureSupportStatus(getSupportParam(params, ["android", "Android"])),
      ios: parseFeatureSupportStatus(getSupportParam(params, ["ios", "iOS", "IOS"])),
    });
  }, []);

  const heroCopy = getHeroCopy(supportState);

  return (
    <>
      <div className="relative mds-container mds-grid">
        <Hero
          className="col-span-full md:col-span-6 md:col-start-2 lg:col-start-4"
          headline={heroCopy.title}
          headlineSize="4"
          body={heroCopy.subtitle}
          bodySize="1"
          level={1}
          layout="center"
        />
      </div>

      <Container className="py-2xl">
        <div className="relative mx-auto max-w-960 rounded-4xl bg-surface-2 p-2xl">
          <img
            src="/images/sparks/sparky-support-feature.svg"
            alt=""
            aria-hidden="true"
            className="absolute right-[-100px] top-[-200px] hidden h-200 w-auto lg:block"
          />
          <img
            src="/images/sparks/success-paperclip.svg"
            alt=""
            aria-hidden="true"
            className="absolute left-[3.81%] top-[-18px] w-[45px] h-[90px]"
          />
          <div className="relative mds-grid items-start gap-y-2xl lg:before:content-[''] lg:before:absolute lg:before:inset-y-0 lg:before:left-1/2 lg:before:w-px lg:before:bg-neutral-200">
            <div className="col-span-full lg:col-span-6">
              <SparksPlatformSupportCard
                platform="android"
                title="Android"
                support={supportState.android}
                minVersion={ANDROID_MIN_VERSION}
                storeUrl={ANDROID_PLAY_STORE_URL}
              />
            </div>
            <div className="col-span-full lg:col-span-6">
              <SparksPlatformSupportCard
                platform="ios"
                title="Apple"
                support={supportState.ios}
                minVersion={IOS_MIN_VERSION}
                storeUrl={IOS_APP_STORE_URL}
              />
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};
